import ReportComponent from '../../utils/ReportComponent/ReportComponent';
import resolveMetricsConfig from '../../helpers/reportMetrics';
import typeOf from '../../helpers/typeOf';
import config from '../../config';

const reportFormatter = ReportComponent.formatter;
const reportUtils = ReportComponent.utils;
const numericFormats = new Set(['number', 'percent', 'currency']);

const getMetricsFromParameters = (parameters = {}) => {
    return resolveMetricsConfig(parameters, {}, parameters.metricsBinary, reportUtils).keys;
};

const getCellClass = (key, parameters = {}) => {
    const params = key === 'GroupBy'
        ? {
            metricKey: key,
            key: parameters.group_by
        }
        : key;

    const format = reportFormatter.getParams(params)?.format;
    return numericFormats.has(format) ? 'number' : 'text';
};

export const getMetric = (key, value, parameters, isTotals = false) => {
    let params = key;
    if (key === 'GroupBy') {
        params = {
            metricKey: key,
            key: parameters.group_by,
            isTotals
        };
    }

    return reportFormatter.format(value, params, parameters);
};

export const getTr = (data, parameters, isTotals) => {
    let str = '<tr>';
    const currentMetrics = getMetricsFromParameters(parameters);

    (currentMetrics || []).map((key) => {
        let value = getMetric(key, data[key], parameters, isTotals);

        if (typeOf.isArray(value)) {
            value = `${value[0]}${config.XBT}`;
        }

        str += `<td class="${getCellClass(key, parameters)}">${value}</td>`;
    });

    str += '</tr>';

    return str;
};
